import { combineReducers } from "redux";

import { loginReducer } from "../Containers/Login/reducer";
import { adminReducer } from "../Containers/AdminPage/reducer";
import { socketReducer } from "../services/socketService/reducer";
import { storesReducer } from "../Containers/MainPage/reducer";
import { managementReducer } from "../Containers/Management/reducer";
import { dialogReducer } from "../Containers/Dialog/reducer";
import { languageSelector } from "../Containers/LanguageSelector/reducer";

export default combineReducers({
  loginReducer,
  adminReducer,
  socketReducer,
  storesReducer,
  managementReducer,
  dialogReducer,
  languageSelector,
});
